import { render, staticRenderFns } from "./rides.vue?vue&type=template&id=5d79361d&scoped=true&"
import script from "./rides.vue?vue&type=script&lang=js&"
export * from "./rides.vue?vue&type=script&lang=js&"
import style0 from "./rides.vue?vue&type=style&index=0&id=5d79361d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d79361d",
  null
  
)

export default component.exports